import axios from 'axios'

const TeamService = {
  async list(params = {}) {
    return axios.get('users', { params })
  },

  async destroy(id) {
    return axios.delete(`users/${encodeURIComponent(id)}`)
  },

  // NEW: effective access for current auth user
  async effective(params = {}) {
    // Your route is just /effective (relative to axios baseURL)
    return axios.get('effective', { params })
  }
}

export default TeamService
